import Amount from "@/models/Shared/Amount";

export default class ScheduledFee {
    id: string = '';
    overridable: boolean = false;
    enabled: boolean = false;
    name: string = '';
    subTransactionType: string = '';
    reference: string = '';
    periodValue: number = 1;
    periodType: string = '';
    periodOnDayOfWeek: string = '';
    periodOnDayOfMonth: string = '';
    periodDayOfMonth: number = 1;
    periodOnMonth: string = '';
    amount: Amount = new Amount();
    introductoryPeriodValue: number = 1;
    introductoryAmount: Amount = new Amount();
}